export default "__VITE_ASSET__DxKEYQh7__"